import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { IHeroImageBackground } from '../../_shared/models/hero/hero-image-background.model';
import { ImageDataDb } from '../../_shared/data/image-data-db.data';
import { MediaImage } from '../../_shared/models/media/media-image.model';
import { HeroBase } from '../hero-base.directive';
import { ImageItemComponent } from '../../media/media-item/image-item/image-item.component';
import { ContainerComponent } from '../../container/container.component';

import { HeadingComponent } from '../../heading/heading.component';
import { ButtonComponent } from '../../button/button.component';
import { CastPipe } from '../../_shared/pipes/cast.pipe';
import { LinkDirective } from '../../_shared/directives/link.directive';
import { TextHtmlComponent } from '../../text-html/text-html.component';
import { SECTION_SURFACE } from '../../section/section-surface';
import { BackgroundVariant } from '../../_shared/models/hero/hero-variant.enum';

@Component({
    selector: 'sirius-hero-image-background',
    templateUrl: './hero-image-background.component.html',
    styleUrls: ['./hero-image-background.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.sir-hero-has-mobile-image]': '!!(backgroundImageMobile ?? backgroundMobileImage)',
        // A light variant sets nothing and inherits its section's mode.
        '[class.is-dark]': 'variant === "dark"',
        // Deprecated alias, kept for one release.
        '[class.sir-hero-variant-dark]': 'variant === "dark"',
        '[class.is-on-surface]': 'showsSectionColour',
    },
    imports: [
    ImageItemComponent,
    ContainerComponent,
    CastPipe,
    HeadingComponent,
    ButtonComponent,
    LinkDirective,
    TextHtmlComponent
]
})
export class HeroImageBackgroundComponent extends HeroBase implements OnInit {
    @Input() backgroundImageDesktop?: MediaImage;
    @Input() backgroundImageMobile?: MediaImage;
    /** @deprecated Use backgroundImageDesktop instead. */
    @Input() backgroundDesktopImage?: MediaImage;
    /** @deprecated Use backgroundImageMobile instead. */
    @Input() backgroundMobileImage?: MediaImage;

    config?: IHeroImageBackground;

    protected readonly sectionSurface = inject(SECTION_SURFACE, { optional: true });

    // Transparent in a coloured section, except a dark hero in a light one: it keeps its dark fill
    // so its text stays readable.
    protected get showsSectionColour(): boolean {
        const mode = this.sectionSurface?.surfaceMode();
        return !!mode && (this.variant !== BackgroundVariant.DARK || mode === 'dark');
    }

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.textHtml = this.config.textHtml;
            this.buttonPrimary = this.config.buttonPrimary;
            this.buttonSecondary = this.config.buttonSecondary;
            this.backgroundImageDesktop = this.config.backgroundImageDesktop ?? this.config.backgroundDesktopImage;
            this.backgroundImageMobile = this.config.backgroundImageMobile ?? this.config.backgroundMobileImage;
            this.variant = this.config.variant;
        }

        if (this.variant) {
            this._breadcrumbService.setVariant(this.variant);
        }

        this.imageData = ImageDataDb.hero.image;
    }
}
